import { render, staticRenderFns } from "./MSSaleDashboard.vue?vue&type=template&id=1c588e6c&"
import script from "./MSSaleDashboard.vue?vue&type=script&lang=js&"
export * from "./MSSaleDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports